<template>
    <ContainerWithMenu>
        <div class="page-content">
            <div class="row margin-bottom-20">
                <div class="col-xs-12 col-md-5">
                    <h1 class="h2 margin-0">{{ $t('views.clients.title') }}</h1>
                </div>
                <div class="col-xs-12 col-md-7 text-right">
                    <button
                            class="btn btn-primary btn-action-mobile"
                            @click="showAddClientModal"
                    >
                        <i class="las la-user-plus"></i>
                        <span class="button-text">{{ $t('views.clients.new_client') }}</span>
                    </button>
                </div>
            </div>
            <ClientTable v-if="clients.length > 0" @new-reservation-client-click="newReservationClientClick" :clients="clients"></ClientTable>
            <div v-else>
                <span class="text-muted">{{ $t('views.clients.not_found') }}</span>
            </div>
            <div class="text-center">
                <Pagination
                        v-show="numberPagesClients > 1"
                        :page-count="numberPagesClients"
                        :click-handler="paginateCallback" />
            </div>
        </div>
        <SpinnerLoader v-show="loading"></SpinnerLoader>
        <AddClientModal v-show="addClientModalVisible" :visible="addClientModalVisible" @close-client-modal="addClientModalVisible=false"></AddClientModal>
        <NewReservationModal v-show="newReservationModalVisible"
                             :visible="newReservationModalVisible"
                             :client-id="clientSelected"
                             @success-new-reservation="onSuccessNewReservation"
                             @close-new-reservation-modal="newReservationModalVisible=false"></NewReservationModal>
    </ContainerWithMenu>
</template>

<script>
    import ContainerWithMenu from "../components/container/ContainerWithMenu";
    import ClientTable from "../components/client/ClientTable";
    import {getClients} from "../api";
    import SpinnerLoader from "../components/common/SpinnerLoader";
    import AddClientModal from "../components/modal/AddClientModal";
    import NewReservationModal from "../components/modal/NewReservationModal";
    import {Utils} from "../common/utils";
    import Pagination from "../components/common/Pagination";

    const LIMIT_CLIENTS = 100;

    export default {
        title: 'Clienti',
        name: "Clients",
        data: function () {
            return {
                clients: [],
                clientSelected: null,
                countClients: 0,
                limitClients: LIMIT_CLIENTS,
                currentPageClient: 1,
                loading: false,
                addClientModalVisible: false,
                newReservationModalVisible: false
            }
        },
        components: {Pagination, ContainerWithMenu, ClientTable, SpinnerLoader, AddClientModal, NewReservationModal},
        mounted() {
            this.getClients()
        },
        computed: {
            numberPagesClients: function () {
                return Utils.getNumberPageByCountLimit(this.countClients, this.limitClients);
            }
        },
        methods: {
            newReservationClientClick(clientId) {
                this.clientSelected = clientId;
                this.newReservationModalVisible = true;
            },
            onSuccessNewReservation() {
                this.clientSelected = null;
                this.newReservationModalVisible = false;
            },
            async getClients(page = 1) {
                this.loading = true;
                try {
                    let clientsResponse = await getClients(page, this.limitClients);
                    this.countClients = clientsResponse.count;

                    this.saveClientsWithSeparator(clientsResponse);
                    this.loading = false;
                } catch (e) {
                    this.loading = false;
                    console.log(e)
                }
            },
            saveClientsWithSeparator(clientsResponse) {
                const clients = clientsResponse.results;
                let clientsWithSeparators = [];
                for (let i = 0; i < clients.length; i++) {
                    if (i === 0) {
                        clientsWithSeparators.push({ separator: true, separator_letter: clients[i].first_name.charAt(0).toUpperCase()});
                        clientsWithSeparators.push(clients[i])
                    } else if (clients[i].first_name.charAt(0).toUpperCase() !== clients[i-1].first_name.charAt(0).toUpperCase()) {
                        clientsWithSeparators.push({ separator: true, separator_letter: clients[i].first_name.charAt(0).toUpperCase()});
                        clientsWithSeparators.push(clients[i])
                    } else {
                        clientsWithSeparators.push(clients[i])
                    }
                }
                this.clients = clientsWithSeparators;
            },
            paginateCallback(pageNum) {
                this.getClients(pageNum)
            },
            showAddClientModal() {
                this.addClientModalVisible = true
            }
        }
    };
</script>
